import React from "react";
import PropTypes from "prop-types";
import translations from "../translation"; // Assuming translations is in the specified path

const OpenModal = ({ isOpen, onClose, title, tableData, tableHeaders, language }) => {
  if (!isOpen) return null;

  const translate = (key) => translations[language][key] || key; // Translation function

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(); // Close modal when clicking outside the content
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={handleOverlayClick}>
      <div className="bg-white w-full max-w-4xl max-h-[90vh] shadow-lg rounded-lg p-6 overflow-auto relative">
        
        {/* Modal Header */}
        <div className="flex items-center justify-between mb-4">
          {title && <h2 className="text-lg font-bold">{title}</h2>}
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-white bg-red-500 hover:bg-red-400 rounded-lg font-medium"
          >
            {translate("close")}
          </button>
        </div>

        {/* Table Content */}
        <div className="overflow-x-auto">
          {tableData && tableData.length > 0 ? (
            <table className="w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {tableHeaders.map((header, index) => (
                    <th
                      key={index}
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {translate(header)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {tableData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {Object.values(row).map((cell, cellIndex) => (
                      <td
                        key={cellIndex}
                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-center text-gray-500 py-4">
              {translate("noDataAvailable")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

OpenModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
  language: PropTypes.string.isRequired, // Add language as a prop
};

export default OpenModal;
